module.exports = __webpack_public_path__ + "static/img/invoice_financing_loan copy.e9a4e39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/invoice_financing_loan copy.png
// module id = 1749
// module chunks = 5